// ================================================================================
// front-page.js
// TOP 用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 961px)' )
	const breakpointLarge = window.matchMedia( 'screen and (min-width: 1200px)' )
	const breakpointLaptop = window.matchMedia( 'screen and (min-width: 1280px)' )


	// main background
	// --------------------------------------------------------------- //
	let frontMainBacground = new Swiper ('#js-main-background', {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		grabCursor: false,
		simulateTouch: false,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		speed: 1800,
	} );



	// front pickup
	// --------------------------------------------------------------- //
	let frontPickupSwiper = new Swiper ('#js-front-pickup', {
		slidesPerView: 'auto',
		spaceBetween: 20,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );


	// front page swiper
	// --------------------------------------------------------------- //

	let blogFlag = document.getElementById('js-front-blog');

	// swiper 部分
	let frontBlogSwiper;

	const breakpointChecker = function() {
		if ( breakpoint.matches === false ) {
			if ( frontBlogSwiper !== undefined ) frontBlogSwiper.destroy( true, true );
			return;

		} else if ( breakpoint.matches === true ) {
			return enableSwiper();

		}
	};

	const enableSwiper = function() {
		frontBlogSwiper = new Swiper ('.js-blog-carousel', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			observer: true,
			observeParents: true,
		} );
	};

	if ( blogFlag ) {
		breakpoint.addListener(breakpointChecker);

		breakpointChecker();
	}


	// タブ
	const blogNav = document.querySelectorAll('.js-blog-nav')
	const blogContent = document.getElementById('js-blog-all')
	let initBlogHtml = ''
	if ( blogContent ) {
		initBlogHtml = blogContent.innerHTML
	}

	for ( let i = 0; i < blogNav.length; i++ ) {

		blogNav[i].addEventListener('click', () => {

			if ( !blogNav[i].classList.contains('is-active') ) {
				for (let elm of blogNav) {
					elm.classList.remove('is-active');
				}

				blogNav[i].classList.add('is-active');

				// カテゴリー情報を取得
				let term_id = blogNav[i].dataset.id
				let term_url = blogNav[i].getAttribute('href')
				let term_title = blogNav[i].textContent

				// モバイルと pc で処理を別にしておく
				if ( breakpoint.matches === true ) {
					if ( term_id == 0 ) {
						frontBlogSwiper.removeAllSlides()
						frontBlogSwiper.appendSlide(initBlogHtml)
					} else {
						frontBlogSwiper.removeAllSlides()
						//frontBlogSwiper.appendSlide($$test)
						 restBlogParse(term_id, term_url, term_title)
					}
				} else {
					if ( term_id == 0 ) {
						blogContent.innerHTML = '';
						blogContent.insertAdjacentHTML('afterbegin', initBlogHtml);
					} else {
						blogContent.innerHTML = '';
						//blogContent.insertAdjacentHTML('afterbegin', $$test);
						restBlogParse(term_id, term_url, term_title)
					}
				}

				event.stopPropagation();
				event.preventDefault();
			} else {
				event.stopPropagation();
				event.preventDefault();
			}

		});
	}


	function restBlogParse($id, $link, $title) {
		let request = new XMLHttpRequest();
		request.open('GET', '/wp-json/wp/custom/category/' + $id, true);

		request.onload = function() {
			if (request.status >= 200 && request.status < 400) {
				let resultData = JSON.parse(request.responseText);
				let insertTags = ''

				Object.keys(resultData).forEach(function(key) {
					let dateData = new Date(resultData[key]['date']);
					let year = dateData.getFullYear();
					let month = dateData.getMonth() + 1;
					month = String(month)
					if (month.length == 1 ) {
						month = '0' + month;
					}
					let day = dateData.getDate();

					let $imageUrl = resultData[key]['thumbnail']

					insertTags += '<article class="entry-item swiper-slide">'
						insertTags += '<p class="entry-item__thumb">'
							insertTags += '<a href="' + resultData[key]['url'] + '">'
								insertTags += '<img src="' + $imageUrl + '" alt="' + resultData[key]['title'] + '">'
							insertTags += '</a>'
						insertTags += '</p>'
						insertTags += '<p class="entry-item-categories">'
							insertTags += '<a href="' + $link + '" class="entry-item-categories__link">' + $title + '</a>'
						insertTags += '</p>'
						insertTags += '<h3 class="entry-item__title">'
							insertTags += '<a href="' + resultData[key]['url'] + '">' + resultData[key]['title'] + '</a>'
						insertTags += '</h3>'
						insertTags += '<p class="entry-item__date">'
							insertTags += '<time class="published updated" datetime="' + resultData[key]['date'] + '">' + year + '年' + month + '月' + day + '日' + '</time>'
						insertTags += '</p>'
					insertTags += '</article>'


				})
				//console.log(resultData);

				// 出力
				if ( breakpoint.matches === true ) {
					frontBlogSwiper.appendSlide(insertTags)
				} else {
					blogContent.insertAdjacentHTML('afterbegin', insertTags);
				}

			} else {
				location.href($link);
			}
		};

		request.onerror = function() {
			location.href($link);
		};

		request.send();
	}


} );

